export default "/images/vendor/flag-icon-css/flags/4x3/im.svg?b21ce587e66db16e0428f4f3de36c4d3";